import { render } from "./PackagesList.vue?vue&type=template&id=33ecc662"
import script from "./PackagesList.vue?vue&type=script&lang=js"
export * from "./PackagesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__